export const isLast = (index: number, items: any[]) =>
  index === items.length - 1
